<template lang="pug">
  .component-driver-reservations
    .action-bar
      .title
        h2 Reservations
      .action
        reservation-list-form(:type="'entity-filter'", @filterReservations="applyFilters")
        i.fa.fa-plus-circle.fa-2x(data-toggle="create-reservation" v-if="$acl('vehicles-select-list') && $acl('index-common-cost')")

    .driver-reservations.tabs-inner-content.no-space.fill-bg
      #create-reservation.is-hidden(data-toggler="is-hidden", v-f="" v-if="$acl('vehicles-select-list') && $acl('index-common-cost')")
        h3.title Book for driver DR{{$route.params.id}}
        book-panel(:driverId="$route.params.id")
      base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import ReservationListForm from 'components/structure/ui/filters/ReservationListForm'
  import BookPanel from '../../structure/ui/BookPanel'
  import BaseList from '../../../pages/backoffice/BaseList'

  export default {
    name: 'DriverReservations',
    components: {
      BaseList,
      BookPanel,
      ReservationListForm,
    },
    data() {
      return {
        reservations: [],
        search: {},
        component: require('components/backoffice/Reservation'),
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.drivers.list(page, resultsPerPage, this.search).reservations(this.$route.params.id, (data) => {
          callback(data)
        })
      },
      applyFilters(body) {
        this.$set(this.search, 'status', body.status)

        if (this.search.status === '') {
          delete this.search.status;
        }

      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverReservations.vue?3db105a4